import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ChevronRight, CloudSun, X } from 'lucide-react';
import { useWeather } from '../lib/useWeather';

function WeatherWidget({ condoSlug, active }) {
  const { weather, status } = useWeather(condoSlug);
  const location = useLocation();
  const navigate = useNavigate();

  if (status !== 'ready' || weather.temperature === null) return null;

  const temperature = `${Math.round(weather.temperature)}°C`;
  const action = active ? 'Close weather details' : 'View weather details';

  const handleClick = (event) => {
    const modified = event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    if (!active || modified) return;
    event.preventDefault();
    if (location.state?.fromWeatherWidget) {
      navigate(-1);
    } else {
      navigate(`/${condoSlug}`);
    }
  };

  return (
    <Link
      to={`/${condoSlug}/weather`}
      state={{ fromWeatherWidget: true }}
      onClick={handleClick}
      title={action}
      aria-label={`Weather: ${temperature}. ${action}`}
      className={`flex items-center gap-1.5 px-2 sm:pl-2.5 sm:pr-1.5 py-1.5 rounded-full border text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
        active
          ? 'border-primary bg-primary/10 text-primary'
          : 'border-border text-foreground [@media(hover:hover)]:hover:border-primary [@media(hover:hover)]:hover:bg-muted'
      }`}
    >
      <CloudSun className="h-4 w-4 text-primary" aria-hidden="true" />
      <span>{temperature}</span>
      {active
        ? <X className="hidden sm:block h-4 w-4" aria-hidden="true" />
        : <ChevronRight className="hidden sm:block h-4 w-4 text-muted-foreground" aria-hidden="true" />}
    </Link>
  );
}

export default WeatherWidget;
